<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to cut off list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="company" pageId="upload-attendance" color="white"></help-link>
                    <v-btn dark icon title="Download Template" @click="downloadTemplate" :loading="loading_download">
                        <v-icon>download</v-icon>
                    </v-btn>
                    <v-btn dark icon title="Upload Attendance" @click="showUpload" :loading="loading_upload">
                        <v-icon>upload_file</v-icon>
                    </v-btn>
                    <div v-if="!loading&&hasUploadedData" >
                        <v-menu left v-model="menu_status" offset-y :disabled="frozenPeriod||closedPeriod||!hasEditRights"> 
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(file_detail.status)" dark v-on="on" :loading="loading_status">
                                    &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(file_detail.status)}}&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense v-show="hasEditRights&&validatedStatus">
                                <v-list-tile :key="0" @click="dialogSave=true" title="Save Uploaded Attendance">
                                    <v-list-tile-title small>Save</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                </v-toolbar>
            </v-card>
            <v-alert v-if="!loading&&!hasUploadedData" :value="true" color="warning" icon="warning" outline dismissible>
                <ul>
                    <li>{{uploadReminder.item1}}</li>
                    <li>{{uploadReminder.item2}}</li>
                </ul>
            </v-alert>
            <v-alert v-if="hasUploadedData" :value="true" color="info" icon="info" outline dismissible>
                <ul>
                    <li>{{validatedReminder.item1}}</li>
                    <li>{{validatedReminder.item2}}</li>
                </ul>
            </v-alert>
            <v-card v-if="!loading" class="elavation-1" style="margin-top:5px;"> 
                <v-toolbar flat height="45px">
                    <b>Uploaded Attendance</b>
                    <v-spacer></v-spacer>
                    <b>{{ cutOffPeriod }}</b>
                </v-toolbar>
                <v-data-table
                    :headers="tableHeader"
                    :items="header_employees"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <template v-slot:items="props">
                        <tr>
                            <td>{{props.item.employeeId}}</td>
                            <td>
                                <v-chip style="margin-left:-5px">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}} 
                                </v-chip>
                            </td>
                            <td><span v-if="getClockIn(1, props.item.employeeId)">{{ $moment(getClockIn(1, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(1, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td><span v-if="getClockIn(2, props.item.employeeId)">{{ $moment(getClockIn(2, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(2, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td><span v-if="getClockIn(3, props.item.employeeId)">{{ $moment(getClockIn(3, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(3, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td><span v-if="getClockIn(4, props.item.employeeId)">{{ $moment(getClockIn(4, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(4, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td><span v-if="getClockIn(5, props.item.employeeId)">{{ $moment(getClockIn(5, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(5, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td><span v-if="getClockIn(6, props.item.employeeId)">{{ $moment(getClockIn(6, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(6, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td><span v-if="getClockIn(7, props.item.employeeId)">{{ $moment(getClockIn(7, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(7, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td><span v-if="getClockIn(8, props.item.employeeId)">{{ $moment(getClockIn(8, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(8, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td><span v-if="getClockIn(9, props.item.employeeId)">{{ $moment(getClockIn(9, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(9, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td><span v-if="getClockIn(10, props.item.employeeId)">{{ $moment(getClockIn(10, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(10, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td><span v-if="getClockIn(11, props.item.employeeId)">{{ $moment(getClockIn(11, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(11, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td><span v-if="getClockIn(12, props.item.employeeId)">{{ $moment(getClockIn(12, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(12, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td><span v-if="getClockIn(13, props.item.employeeId)">{{ $moment(getClockIn(13, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(13, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td v-if="isValidDay(14)"><span v-if="getClockIn(14, props.item.employeeId)">{{ $moment(getClockIn(14, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(14, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td v-if="isValidDay(15)"><span v-if="getClockIn(15, props.item.employeeId)">{{ $moment(getClockIn(15, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(15, props.item.employeeId)).format('hh:mmA') }}</span></td>
                            <td v-if="isValidDay(16)"><span v-if="getClockIn(16, props.item.employeeId)">{{ $moment(getClockIn(16, props.item.employeeId)).format('hh:mmA') }}-{{ $moment(getClockOut(16, props.item.employeeId)).format('hh:mmA') }}</span></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
            <v-card v-if="!loading && upload_errors.length" class="elavation-1" style="margin-top:5px;"> 
                <v-toolbar flat height="45px">
                    <b class="red--text">Upload File Errors</b>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="headers_upload_error"
                    :items="upload_errors"
                >
                    <template v-slot:items="props">
                        <tr>
                            <td>{{ props.item }}</td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>

            <!-- previously uploaded for the same team and cutoff -->
            
            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <!-- updates history component -->
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogUpload" fullscreen hide-overlay transition="dialog-bottom-transition"> 
            <upload ref="uploadRef" :dialogUpload.sync="dialogUpload" v-on:send="uploadHandler"></upload>
        </v-dialog>
        <v-dialog v-model="dialogSave" width="500">
            <v-card class="elavation-1" style="border-radius:4px;"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold ">Confirm Save</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="text-xs-center">
                    <p>Save the uploaded attendance?</p>
                    <p>Note: you will not be able to undo this operation.</p>
                </v-card-text>
                 <v-divider></v-divider>
                 <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn title="Save Uploaded Attendance" class="primary" dark @click="saveAttendance" :loading="loading_save">Save</v-btn>
                    <v-btn title="Cancel" @click="dialogSave=false" :disabled="loading_save">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    
        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import attendanceuploadApi from '@/api/attendanceupload'
import commonfn from '@/common/functions'
import myTeamsPermissions from '@/helpers/myteams-permissions'
import AppPageID from '@/constants/app_page_ids'
import notificationTypes from '@/common/notificationTypes'
import pageKeys from '@/common/pagekeys'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'AttendanceUpload',
    metaInfo: {
        title: 'AttendanceUpload',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Attendance Upload' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'upload': () => import('@/components/AttendanceUpload/AttendanceUpload'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,
            loading_download: false,
            loading_status: false,
            loading_save: false,
            menu_status: false,
            headers_upload_error: [
                {text: 'Error Details',align: 'left',value: '', width: '100%', sortable:false},
             ],
            uploadReminder: {
                item1: 'To upload attendance for this cutoff period, download the template, fill in the Clock-In/Clock-Out cells, and then upload the completed file.',
                item2: 'Ensure that each employee has a work shift assigned for each working day of the entire cutoff period. Working days with no work shift will be excluded.'
            },
            validatedReminder: {
                item1: 'The following uploaded attendance records have been validated but not yet saved. You can still re-upload the file if you need to make any updates while the status is Upload Validated.',
                item2: 'Missing clock-in/clock-out entries in the table below indicate that the upload was unsuccessful due to incorrect formatting, a missing work shift plan or attendance already exist.',
            },
            savedReminder: {
                item1: 'The following uploaded attendance records have already been saved. You will not be able to upload for this cutoff period again. Any necessary changes must be made through Attendance Corrections.'
            },
            search: null,
            cutOffItem: null,
            loading_upload: false,
            dialogUpload: false,
            dialogSave: false,
            uploaded_items: [],
            upload_errors: [],
            file_detail: null,
            header_dates: null,
            header_employees: null
        }
    },
    methods: {
        uploadHandler(response) {
            this.upload_errors = response.uploadErrors
            //this can be saved in DB in the future.
            localStorage.upload_errors = JSON.stringify(response.uploadErrors)
            
            this.getUploaded(false)
        },
        async saveAttendance() {
            try {
                this.loading_save = true
                const response = await attendanceuploadApi.save(this.selectedCutoffId)
                if (response && response.status == 200) {
                    delete localStorage.upload_errors
                    await this.getUploaded(false)
                }
                this.loading_save = false
                this.dialogSave = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        isValidDay(day) {
            const transDate = this.header_dates.filter(x => x.day == day)
            return transDate != null && transDate.length
        },
        getClockIn(day, employeeId) {
            const transDate = this.header_dates.filter(x => x.day == day)[0].transDate
            const data = this.uploaded_items.filter(x => x.employeeId == employeeId && x.transDate == transDate)
            if (data.length) return data[0].clockIn
            return null
        },
        getClockOut(day, employeeId) {
            const transDate = this.header_dates.filter(x => x.day == day)[0].transDate
            const data = this.uploaded_items.filter(x => x.employeeId == employeeId && x.transDate == transDate)
            if (data.length) return data[0].clockOut
            return null
        },
        async showUpload() {
            this.$refs.uploadRef.setData(this.selectedCutoffId)
            this.dialogUpload = true
        },
        async downloadTemplate() {
            try {
                this.loading_download = true
                const response = await attendanceuploadApi.dowloadTemplate(this.selectedCutoffId)
                var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `ATTENDANCE-UPLOAD-TEMPLATE-${this.cutoffFileHeader}.xlsx`
                link.click()
                this.loading_download = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getUploaded(show_loading) {
            try {
                this.loading = show_loading
                const response = await attendanceuploadApi.getUploaded(this.selectedCutoffId)   
                if (response && response.status == 200) {
                    this.header_employees = response.data.headerEmployees
                    this.cutOffItem = response.data.cutoff
                    this.uploaded_items = response.data.items
                    this.header_dates = response.data.headerDates
                    this.file_detail = response.data.file
                    this.upload_errors = JSON.parse(localStorage.upload_errors || '[]');
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }, 
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getUploaded(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        await this.getUploaded(true)
        
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.$store.state.selectedTeamName} Upload Attendance`
        })
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        selectedCutoffId() {
            return this.$route.params.cutOffId
        },
        hasEditRights() {
            return myTeamsPermissions.hasTeamEditRights(AppPageID.UploadAttendance)
        },
        companyId() {
            return this.$store.state.companyId
        },
        pageQueryId() {
            return `AttendanceUpload_${this.companyId}_${this.selectedCutoffId}`
        },
        frozenPeriod(){
            if (this.cutOffItem!=null)
                return this.cutOffItem.status==commonfn.getStatusCode('Frozen')
        },
        validatedStatus() {
            if (this.file_detail) 
                return this.file_detail.status==commonfn.getStatusCode('Upload Validated')
        },
        closedPeriod(){
            if (this.cutOffItem!=null)
                return this.cutOffItem.status==commonfn.getStatusCode('Closed')
        },
        cutOffPeriod() {
            if (this.cutOffItem!=null)
                return `${this.$moment(this.cutOffItem.cutOffStart).format('MMM DD, YYYY')} to ${this.$moment(this.cutOffItem.cutOffEnd).format('MMM DD, YYYY')}`
        },
        cutoffFileHeader() {
            if (this.cutOffItem!=null)
                return `${this.$moment(this.cutOffItem.cutOffStart).format('YYYYMMDD')}-${this.$moment(this.cutOffItem.cutOffEnd).format('YYYYMMDD')}`
        },
        hasUploadedData() {
            if (!this.loading) {
                return this.header_employees && this.header_employees.length > 0
            }
        },
        tableHeader() {
            if (!this.loading) {
                var headerData = []
                headerData.push(
                    {
                        text: 'Employee Id', 
                        align:'left', 
                        value:'employeeId', 
                        width:'', 
                        sortable:true
                    },
                )
                headerData.push(
                    {
                        text: 'Employee', 
                        align:'left', 
                        value:'lastName', 
                        width:'', 
                        sortable:true
                    },
                )
                this.header_dates.forEach(dt => {
                    headerData.push(
                        {
                            text: this.$moment(dt.transDate).format('ddd DD'), 
                            align:'center', 
                            value: '', 
                            width:'', 
                            sortable:false
                        },
                    )
                })
                return headerData
            }
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.attendance_upload,
                    notificationTypeId: notificationTypes.upload_attendance
                }
            }
        },
    }
}
</script>